import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import { Get_Error, Transfere_Leads_TO_Data_Center } from '../Types';

export const Transfere_Leads_TO_Data_Center_Action = (leadIds) => async (dispatch) => {
  try {
    console.log('🔍 [ACTION] Starting transfer with leadIds:', leadIds);
    console.log('🔍 [ACTION] leadIds type:', typeof leadIds);
    console.log('🔍 [ACTION] Is array?', Array.isArray(leadIds));
    console.log('🔍 [ACTION] leadIds length:', leadIds?.length);

    // تأكد أن leadIds هو array
    if (!Array.isArray(leadIds)) {
      console.error('❌ [ACTION] leadIds is not an array!');
      throw new Error('leadIds must be an array');
    }

    if (leadIds.length === 0) {
      console.error('❌ [ACTION] leadIds array is empty!');
      throw new Error('leadIds array cannot be empty');
    }

    console.log('🚀 [ACTION] Calling useinsertdatawithoutimage...');

    const res = await useinsertdatawithoutimage(
      `/api/v1/users/transfer-to-data-center`,
      { leadIds }, // إرسال leadIds كـ body
    );

    console.log('✅ [ACTION] Response received:', res);

    dispatch({
      type: Transfere_Leads_TO_Data_Center,
      payload: res,
    });

    return res;
  } catch (e) {
    console.error('❌ [ACTION] Error caught:', e);
    console.error('❌ [ACTION] Error response:', e.response?.data);

    dispatch({
      type: Get_Error,
      payload: e.response?.data || e.message,
    });

    throw e;
  }
};
